/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/repair': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M15.5 6.5l-2-2 2-2h-1a3 3 0 00-3 3c0 .463.113.895.3 1.286l-6.788 6.788A2.01 2.01 0 004.5 13.5a2 2 0 102 2 2.01 2.01 0 00-.074-.512L13.214 8.2c.392.187.823.3 1.286.3a3 3 0 003-3v-1l-2 2zm-11 10a1 1 0 110-2 1 1 0 110 2z"/>'
  }
})
